import React from 'react'
import './CustomEmpty.scss'
function CustomEmpty({moduleName}) {
  return (
    <div className='cntnr'>
      <i class="dx-icon-warning"></i>
      <div className='upperDiv'>No {moduleName} to display!</div>
    </div>
  )
}
 
export default CustomEmpty;